import { Panel, Table } from '@/components/Bicester';
import { Cell } from '@/components/Bicester/Table';
import {
  DateTimeCell,
  OperationCell,
  ShoppingVillageCell,
} from '@/components/Bicester/Table/Cells';
import StatusCell from '@/components/Bicester/Table/Cells/StatusCell';
import { ROLE_TYPE } from '@/constants';
import { BICESTER_FULL_DATE_TIME } from '@/constants/dateFormat';
import useServiceBasic from '@/hooks/preload/useServiceBasic';
import useRouter from '@/hooks/useRouter';
import useTable from '@/hooks/useTable';
import { useReadyInfo } from '@/providers/ReadyProvider';
import { fetchServiceList } from '@/services/service';
import { push } from '@/utils/history';
import { SiteDetailPage, SubscribeDetailPage } from '@/views/SiteService/Record/constants';
import { getDetailPath } from '@/views/SubscribeService/constants';
import { useRequest } from 'ahooks';
import _ from 'lodash';
import React from 'react';

const ServiceRecord = () => {
  const { match, pathname } = useRouter<{ id: string }>();
  const { data: serviceBasic, loading: serviceBasicLoading } = useServiceBasic();
  const { profile } = useReadyInfo();

  const {
    run: getServiceList,
    data: { content_list: recordListData, current_page, total } = {},
    loading: recordListLoading,
  } = useRequest(fetchServiceList, { manual: true });

  const { onChange, onSearch } = useTable(async (p) => {
    const params = Object.assign({}, p, {
      [pathname.includes('no-member') ? 'not_member_id' : 'member_id']: match.params.id,
    });
    await getServiceList(params);
  });

  return (
    <Panel
      title="服务记录"
      expanded
      defaultExpand={false}
      onExpand={(expanded) =>
        expanded &&
        !recordListData?.length &&
        getServiceList({
          page: 1,
          [pathname.includes('no-member') ? 'not_member_id' : 'member_id']: match.params.id,
        })
      }
      subTitle={`总计 ${total || 0} 条`}
      loading={serviceBasicLoading}
    >
      <Table
        pageInfo={{ page: current_page, total }}
        data={recordListData ?? []}
        loading={recordListLoading}
        columns={[
          {
            columnProps: {
              flexGrow: 2,
            },
            header: '服务购物村',
            cell: <ShoppingVillageCell dataKey="shopping_village" />,
          },
          {
            columnProps: {
              flexGrow: 2,
            },
            header: '服务创建时间',
            cell: <DateTimeCell dataKey="created_at" format={BICESTER_FULL_DATE_TIME} />,
          },
          {
            columnProps: {
              flexGrow: 2,
            },
            header: '服务项目',
            cell: <Cell dataKey="type_name" />,
          },
          {
            columnProps: {
              flexGrow: 2,
            },
            header: '服务状态',
            cell: <StatusCell dataKey="status" statusOptionsData={serviceBasic?.service_status} />,
          },
          {
            columnProps: {
              flexGrow: 1,
            },
            header: '服务记录详情',
            cell: (
              <OperationCell
                onClick={(rowData) => {
                  const { id, type } = rowData;
                  if (
                    Object.keys(SiteDetailPage)
                      .map((key) => Number(key))
                      .includes(type)
                  ) {
                    push(`/site-service/record/info/${SiteDetailPage[type]}/${id}`);
                    window.scrollTo({ top: 0 });
                  } else if (
                    Object.keys(SubscribeDetailPage)
                      .map((key) => Number(key))
                      .includes(type)
                  ) {
                    push(`${getDetailPath(SubscribeDetailPage[type])}/${id}`);
                    window.scrollTo({ top: 0 });
                  }
                }}
              />
            ),
          },
        ].filter(
          (column) => !(profile?.role === ROLE_TYPE.DRT && column.header === '服务记录详情') // 导购大使没有服务详情页面
        )}
        onChange={onChange}
      >
        <Table.Body isEmptyHoverBody={false} />
        <Table.Pagination />
      </Table>
    </Panel>
  );
};

export default ServiceRecord;
